Ext.define('SA.EditRules', {
    singleton: true,

    requireAttribute(model) {
        return new SA.EditAttributeRequiredRule(model);
    },

    requireBusiness(model) {
        return new SA.EditBusinessRequiredRule(model);
    },

    requireLocation(model) {
        return new SA.EditLocationRequiredRule(model);
    }
});